export default {
    key: 'eigerrun',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    activityId: '43a8e505-a5af-4302-987a-5b2f514fd9e2',
    categoryId: undefined,
    defaultDuration: 1440,
    isMultiDay: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    showDuration: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: '43a8e505-a5af-4302-987a-5b2f514fd9e2',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-eigerrun-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-eigerrun-steps-step-2-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],
} satisfies ProductConfigActivity;
